// | ------------------------------------------------------------------------
// | Imports
// | ------------------------------------------------------------------------

// Bootstrap ----------------------------------------------------------------

import "@popperjs/core"; // Popper is required for dropdowns, popovers and tooltips.
import {
    Alert,
    Button,
    //Carousel,
    Collapse,
    Dropdown,
    Modal,
    //OffCanvas,
    //Popover,
    //ScrollSpy,
    Tab,
    //Toast,
    //Tooltip,
} from "bootstrap";

// Bootstrap overrides, calls and template integration
import "./bootstrap/collapse";
import "./bootstrap/modals";
//import "./bootstrap/offcanvas";
//import "./bootstrap/popovers";
//import "./bootstrap/tooltips";

// Expose Modal globally
window.BootstrapModal = Modal;


// Imports ------------------------------------------------------------------

//? https://kingsora.github.io/OverlayScrollbars/
import { OverlayScrollbars } from "overlayscrollbars"; // Used in /components/shop/productFilters

//? https://splidejs.com/
import Splide from "@splidejs/splide"; // Used in /components/shop/productGallery

//import fsLightbox from "fslightbox";

//? https://github.com/michalsnik/aos
import AOS from "aos"; // Used in /components/animateOnScroll

//? https://github.com/yowainwright/shave
import shave from "shave"; // Used in /components/ellipsis

//? https://gsap.com/
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

//? https://github.com/darkroomengineering/lenis/blob/main/README.md
//import Lenis from 'lenis'


// ---------------------------------------------------------------------------------

// | ------------------------------------------------------------------------
// | Components
// | ------------------------------------------------------------------------

// Cookie popup
import "./components/cookiePopup";

// | Layout -----------------------------------------------------------------

import "./components/fixedHeader";

// | Navigation -------------------------------------------------------------

import "./components/mainNavigation";

// | Content ----------------------------------------------------------------

import "./components/shave";
import "./components/modals";
import "./components/quoteModal";
import "./components/projectItems";
import "./components/contactMap";
import "./components/forms";

// Carousels
import "./components/itemCarousel";
// import "./components/benefitsCarousel";
//import "./components/projectImgCarousel";
import "./components/clientFeedbackCarousel";

// | Animations -------------------------------------------------------------

//import "./components/smoothScroll";
import "./components/animateOnScroll"; // Animate elements on page scroll
import "./gsap/index"; // GSAP Animations

// | ------------------------------------------------------------------------
// | Code
// | ------------------------------------------------------------------------



// | ------------------------------------------------------------------------